export default __webpack_public_path__ + "static/media/log-out.63039e3f.svg";